import script from "./BTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BTable.vue?vue&type=script&setup=true&lang=ts"

import "./BTable.vue?vue&type=style&index=0&id=74aec852&lang=scss"

const __exports__ = script;

export default __exports__